// A Development's EnquireForm/RequestVisitForm are shared across every
// trigger that opens them (the sidebar CTAs, and one per plot) - see
// modal.js's data-modal-content-id. This fills in the shared form's
// "development"/"plot" Global Form Fields (see LeadCaptureForm's "Global Form
// Fields" tab in the CMS) from whichever trigger was actually clicked, so the
// submission carries that context - and resets the shared form back to its
// original, pristine state whenever the modal closes, since a submission's
// "thank you" state (or values a visitor started filling in) would otherwise
// still be showing the next time anyone opens it for a different plot/enquiry.
const CONTEXT_FIELDS = {
    developmentId: 'development',
    plotId: 'plot',
}

const applyContext = (trigger) => {
    const contentId = trigger.dataset.modalContentId
    const content = contentId && document.getElementById(contentId)
    if (!content) return

    Object.entries(CONTEXT_FIELDS).forEach(([datasetKey, fieldName]) => {
        const field = content.querySelector(`input[name="${fieldName}"]`)
        if (field) field.value = trigger.dataset[datasetKey] || ''
    })
}

// Snapshotted before any interaction can mutate them (a successful submission
// replaces the form markup entirely with a "thank you" fragment - see
// main.js's submitFormAjax()), so there's always a known-good copy to restore.
const pristineContent = new Map()

const capturePristineContent = () => {
    document.querySelectorAll('.js-modal-content').forEach((el) => {
        if (el.querySelector('.lead-capture-form')) {
            pristineContent.set(el, el.innerHTML)
        }
    })
}

const resetLeadCaptureForms = () => {
    pristineContent.forEach((html, el) => {
        el.innerHTML = html
        // A form parsed back in via innerHTML has none of the validation/AJAX
        // submit listeners main.js already set up on the original - same
        // reason it re-inits a fresh <form> after a multi-step response.
        const form = el.querySelector('form')
        if (form) window.SdotsLeadCapture?.initLeadCaptureForm(form)
    })
}

export const leadCaptureFormContextInit = () => {
    capturePristineContent()

    // Capture phase, not bubble - modal.js's own click handler (also
    // delegated on document.body) *moves* this same content's children into
    // the modal on the same click. A bubble-phase listener here would run
    // after or before that move depending purely on which script happened to
    // import first; capturing guarantees this always runs first, while the
    // fields are still findable in their original location.
    document.body.addEventListener('click', (event) => {
        const trigger = event.target.closest('[data-lead-capture-context]')
        if (trigger) applyContext(trigger)
    }, true)

    // Modal.ss/MicroModal toggle aria-hidden on the shared modal itself for
    // every close path (overlay click, close button, Escape) - watching it
    // directly here means resetting doesn't depend on wiring into any one of
    // those paths individually.
    const modalEl = document.getElementById('modal-default')
    if (!modalEl) return
    new MutationObserver((mutations) => {
        const closed = mutations.some((mutation) => mutation.attributeName === 'aria-hidden')
            && modalEl.getAttribute('aria-hidden') === 'true'
        if (closed) resetLeadCaptureForms()
    }).observe(modalEl, { attributes: true, attributeFilter: ['aria-hidden'] })
}

leadCaptureFormContextInit()
